import React from "react";
import { exportLeaveDetailed } from "../Api/PayrollAttendanceservice";
import "../Styling/PayrollTheme.css";
import { useAuth } from "../Context/AuthContext";

const PayrollLeavesDetailedGrid = ({
  data = [],
  page,
  pageSize,
  total,
  onPageChange,
  filters,
}) => {
  const { user } = useAuth();
  const orgId = user?.organisationId;
  const totalPages = Math.ceil(total / pageSize) || 1;

  const exportCSV = async () => {
    try {
      const { page: _p, pageSize: _ps, ...cleanFilters } = filters;

      const fullData = await exportLeaveDetailed(cleanFilters, orgId);

      if (!fullData || fullData.length === 0) return;

      const headers = Object.keys(fullData[0]).join(",");
      const rows = fullData.map((d) => Object.values(d).join(",")).join("\n");

      const blob = new Blob([headers + "\n" + rows], {
        type: "text/csv",
      });

      const url = URL.createObjectURL(blob);

      const hasFilters =
        cleanFilters.resourceName ||
        cleanFilters.resourceId ||
        cleanFilters.fromDate ||
        cleanFilters.toDate;

      const a = document.createElement("a");
      a.href = url;
      a.download = hasFilters ? "leaves_filtered.csv" : "leaves_full.csv";
      a.click();

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  return (
    <div className="pac-grid__card">
      {/* Toolbar */}
      <div className="pac-grid__toolbar">
        <button className="pac-grid__export-btn" onClick={exportCSV}>
          ↓ Export CSV
        </button>
      </div>

      {/* Table */}
      <div className="pac-grid__scroll">
        <table className="pac-grid__table">
          <thead className="pac-grid__thead">
            <tr>
              <th>Resource ID</th>
              <th>Name</th>
              <th>Leave Date</th>
              <th>End Date</th>
              <th>Duration</th>
              <th>Status</th>
              <th>Leave Type</th>
              <th>Line Manager</th>
              <th>Dot Line Manager</th>
            </tr>
          </thead>

          <tbody>
            {!data || data.length === 0 ? (
              <tr>
                <td colSpan={9} className="pac-grid__empty">
                  No records found
                </td>
              </tr>
            ) : (
              data.map((row, i) => (
                <tr key={i}>
                  <td>{row.resourceId}</td>
                  <td>{row.resourceName}</td>
                  <td>{row.leaveDate?.split("T")[0]}</td>
                  <td>{row.endLeaveDate?.split("T")[0] || "—"}</td>
                  <td>{row.leaveDuration}</td>
                  <td>{row.leaveStatus}</td>
                  <td>{row.leaveTypeDescription}</td>
                  <td>{row.lineManagerName || "—"}</td>
                  <td>{row.dotLineManagerName || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pac-grid__footer">
        <span className="pac-grid__page-info">
          Page {page} of {totalPages}
        </span>

        <div className="pac-grid__btn-group">
          <button
            className="pac-grid__page-btn"
            disabled={page === 1}
            onClick={() => onPageChange(page - 1)}
          >
            ← Prev
          </button>

          <button
            className="pac-grid__page-btn"
            disabled={page === totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            Next →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PayrollLeavesDetailedGrid;
